<template>
    <div class="comment">
        <ul class="mb20" v-if="isComment">
            <li v-for="item in comments" class="c-item box">
                <div class="col-1">
                    <img src="../common/images/user-hd.png" alt="">
                </div>
                <div class="col-2 flex-1">
                    <p class="user-name" v-if="item.user_nickname != ''">{{item.user_nickname}}</p>
                    <p class="user-name" v-else>{{fmtMobile(item.mobile)}}</p>
                    <p class="c-content">{{item.content}}</p>
                    <router-link :to='{name:"detailView",params:{detail_type:"mobile",cid:item.category_id,id:item.post_id}}' tag="div" class="article-info box">
                        <div class="art-img"><img v-lazy="resourceUrl+item.thumbnail" :alt="item.post_title"></div>
                        <div class="art-title flex-1">{{item.post_title}}</div>
                    </router-link>
                    <div class="c-date">{{formateTime(item.create_time)}}</div>
                </div>
            </li>
        </ul>
        <infinite-loading @infinite="onInfinite" ref="infiniteLoading">
	      	<span slot="no-more">我是有底线的</span>
	    </infinite-loading>
        <div class="notComment" v-if="!isComment">
            <img src="../common/images/c-no.png" alt="没有评论">
        </div>
        <tip :msgControl="msgShow"><p slot="content">{{tipText}}</p></tip>
    </div>
</template>
<script>
import {httpHead,getCookie,resourceUrl} from '../common/util/config.js';
import InfiniteLoading from 'vue-infinite-loading'
import tip from '../components/tip.vue'
export default {
    data () {
        return {
            mobile: '',
            token: '',
            comments: [],
            resourceUrl,
            page: 0,
            totalPage: 0,
            msgShow: false,
            tipText: '',
            isComment: true
        }
    },
    created() {
        let cookie = document.cookie;
		this.mobile = getCookie(cookie,'mobile');
        this.token = getCookie(cookie,'token');
        httpHead.token = this.token;
        
    },
    methods:{
        msg (){
            this.msgShow =true;
            clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
               this.msgShow =false;
            }, 2000)
        },
        formateTime (date) {
    		let time = new Date(date * 1000);
            let fmt = 'yyyy年mm月dd日'
            if (/(y+)/.test(fmt)) {
    			let year = time.getFullYear();
    			fmt = fmt.replace(RegExp.$1,year);
    		}
    		if (/(m+)/.test(fmt)) {
    			let month = time.getMonth() + 1;
    			month = month < 10 ? '0' + month : month;
    			fmt = fmt.replace(RegExp.$1,month);
    		}
    		if (/(d+)/.test(fmt)) {
    			let day = time.getDate();
    			day = day < 10 ? '0' + day : day;
    			fmt = fmt.replace(RegExp.$1,day);
    		}
    		return fmt;
        },
        fmtMobile (data) {
            let mobile = data.substr(0,3)+'****'+data.substr(7,4);
            return mobile;
        },
        onInfinite ($state) {
            this.page++;
            this.$fetch('api/mycomment/page/'+this.page)
            .then( res => {
                if(res.code == 222){
                    this.msg()
                    this.tipText = res.msg;
                    document.cookie = "mobile=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    document.cookie = "name=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    setTimeout(() => {
                        this.$router.push({ name: 'homeView'})
                    }, 2000)
                }else {
                    this.comments = this.comments.concat(res.data.data);
                    this.totalPage = res.data.last_page
                    $state.loaded();
                    if(res.data.data.length == 0){
                        this.isComment = false
                        $state.complete()
                    }
                    if(this.page == this.totalPage){
                        $state.complete()
                    }
                }
                
            })
        }
    },
    components: {
        InfiniteLoading,
        tip
    }
}    
</script>
<style lang="scss">
.comment{
    ul{
         background:#fff;
    }
    .c-item{
        padding:.2rem .3rem;
        border-bottom: 1px solid #dddddd;
        &:last-child{
            border-bottom: none;
        }
        .col-1{
            width:.8rem;
            height: .8rem;
            margin-right: .2rem;
        }
        .user-name{
            color:#4868af;
            font-size: .24rem;
            padding-top:.12rem;
            margin-bottom: .2rem;
        }
        .c-content{
            font-size: .28rem;
            color:#333;
            margin-bottom: .2rem;
            overflow:hidden;
            line-height:1.5;
        }
        .article-info{
            background:#f5f5f5;
            .art-img{
                height: 1.44rem;
                width: 2.24rem;
                overflow:hidden;
            }
            .art-title{
                padding: 0 .3rem;
                font-size: .28rem;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: .4rem;
                height: .8rem;
                margin-top: .25rem;
            }
        }
        .c-date{
            line-height:1.5;
        }
    }
}
.notComment{
    position: absolute;
    top:.8rem;
    left: 0;
    width: 100%;
    box-sizing:border-box;
    padding:2rem 1rem;
    z-index:99;
    background:#f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/page/commentView.vue